module.exports = __webpack_public_path__ + "img/people-7-min.5809bf04.png";